import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactDOM from 'react-dom';
import ListingThumbnail from 'shared-components/listing-thumbnail/ListingThumbnail';
import gMapUtils from '../../../lib/gmap_utils';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ProjectMap extends Component {
  constructor (props) {
    super(props);

    this.state = {
      hasMounted: false
    };

    this.mapRef = React.createRef();
    this.populateMap = this.populateMap.bind(this);
  }

  componentDidMount () {
    this.setState({
      hasMounted: true
    });
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (!prevState.hasMounted && this.state.hasMounted) {
      const { listings } = this.props;
      this.populateMap();
      if (listings.length) {
        this.populateMarkers(listings);
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    const { listings } = nextProps;
    const currentListings = this.props.listings;

    if (currentListings.length !== listings.length) {
      this.populateMarkers(listings);
    }
  }

  populateMarkers (listings) {
    const assetLocation = '/web-2/assets/images/';
    const fnbPin = '/web-2/assets/images/fnb-map-pin.png?v=rb';
    const fnbSelectedPin = '/web-2/assets/images/fnb-map-pin-selected.png?v=rb';
    const nonFnbPin = '/web-2/assets/images/map-pin.png?v=rb';
    const nonFnbSelectedPin = '/web-2/assets/images/map-pin-selected.png?v=rb';

    const locations = listings.reduce((filtered, listing) => {
      if (listing) {
        const { title, location } = listing;
        const { lat, lon } = location;
        const locationObj = {
          listing,
          lat,
          lon
        };

        filtered.push(locationObj);
      }

      return filtered;
    }, []);

    const markerBounds = new google.maps.LatLngBounds();
    const map = this.map;

    locations.forEach(location => {
      const { listing } = location;
      const position = new google.maps.LatLng(location.lat, location.lon);

      const marker = new google.maps.Marker({
        position,
        map,
        draggable: false,
        icon: listing.fandb_required ? fnbPin : nonFnbPin,
        disableAutoPan: true
      });

      const showPlainMarker = () => {
        marker.setIcon(listing.fandb_required ? fnbPin : nonFnbPin);
      };

      const showSelectedMarker = () => {
        marker.setIcon(listing.fandb_required ? fnbSelectedPin : nonFnbSelectedPin);
      };

      google.maps.event.addListener(marker, 'mouseover', () => {
        showSelectedMarker();
      });

      google.maps.event.addListener(marker, 'mouseout', () => {
        showPlainMarker();
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (window.searchInfoWindow) {
          google.maps.event.trigger(window.searchInfoWindow, 'closeclick');
          window.searchInfoWindow.close();
        }

        const infowindow = new google.maps.InfoWindow({
          content: ReactDOMServer.renderToString(<div className="infowindow-container" id={ `infobox-container-${listing._id}` } />),
          maxWidth: 250
        });
  
        google.maps.event.addListener(infowindow, 'domready', () => {
          ReactDOM.render(this.renderMapPopUp(listing), document.getElementById(`infobox-container-${listing._id}`));
        });

        infowindow.open(map, marker);
        window.searchInfoWindow = infowindow;

        google.maps.event.addListener(map, 'click', () => {
          infowindow.close();
        });
      });

      markerBounds.extend(position);
    });

    google.maps.event.addListenerOnce(map, 'zoom_changed', () => {
      map.setOptions({ maxZoom: 18 });
    });

    google.maps.event.addListenerOnce(map, 'idle', () => {
      map.setOptions({ maxZoom: undefined });
    });

    map.fitBounds(markerBounds);
  }

  populateMap () {
    // const mapContainer = document.getElementById('project-map');
    const map = new google.maps.Map(this.mapRef.current, {
      draggable: true,
      maxZoom: 18
    });

    this.map = map;
  }

  renderMapPopUp (listing) {
    const { _id } = listing;

    const listingData = Object.assign({}, listing, {
      currency: listing['price.currency'],
      hourly_price: listing['price.hourly'],
      review_stars: listing.space_review_stars,
      review_count: listing.space_review_count,
      city: null,
      neighborhood: null
    });

    return (
      <SharedIntlProviderHOC>
        <div className="search-thumbnails map-thumbnails">
          <ListingThumbnail
            key={ _id }
            listing={ listingData }
            listingURL={ `/pages/listings/${_id}` }
            infoBoxClassname="container-fluid"
            reviews
            swipeable
          />
        </div>
      </SharedIntlProviderHOC>
    );
  }

  render () {
    return (
      this.state.hasMounted && (
        <div className='project-map-container'>
          <div ref={this.mapRef} style={{ height: '100%' }}></div>
        </div>
      )
    );
  }
}

export default ProjectMap;
